module.exports = __webpack_public_path__ + "static/media/label.1c2a1230.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Home/Main/label.png
 ** module id = 304
 ** module chunks = 0
 **/